import React, { useEffect, useState } from 'react';
import Axios from 'axios';

const Reports = () => {
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const userId = localStorage.getItem("userId");
    Axios.get(`http://localhost:3006/api/reports/monthly/${userId}`)
      .then((res) => {
        setReportData(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching reports:", err);
        setLoading(false);
      });
  }, []);

  if (loading) return <div style={{ color: 'white', padding: '20px' }}>Loading Financial Data...</div>;

  // --- CORE FINANCIAL CALCULATIONS ---
  
  // 1. Total Invoices
  const totalInvoices = reportData.reduce((acc, curr) => acc + (curr.invoiceCount || 0), 0);

  // 2. Total VAT Sum
  const totalVatSum = reportData.reduce((acc, row) => {
    const gross = Number(row.grossRevenue) || 0;
    const discount = Number(row.totalDiscounts) || 0;
    
    const vatPercent = typeof row.vat === 'string' 
      ? Number(row.vat.replace(/[^0-9.]/g, '')) 
      : (Number(row.vat) || 0);

    const vatAmount = (gross - discount) * (vatPercent / 100);
    return acc + vatAmount;
  }, 0);

  // 3. Net Revenue Including VAT (from your original code)
  const totalNetRevenueIncludingVat = reportData.reduce((acc, curr) => acc + Number(curr.netRevenue || 0), 0);

  // 4. Net Revenue EXCLUDING VAT
  const netRevenueExcludingVat = totalNetRevenueIncludingVat - totalVatSum;

  return (
    <div style={containerStyle}>
      <h2 style={{ color: '#e9edef', marginBottom: '20px', borderBottom: '2px solid #00a884', paddingBottom: '10px' }}>
        Financial Overview
      </h2>

      {/* TOP METRICS CARDS */}
      <div style={statsGrid}>
        <div style={cardStyle}>
          <span style={labelStyle}>Total Invoices</span>
          <h2 style={valueStyle}>{totalInvoices}</h2>
        </div>
        
        <div style={cardStyle}>
          <span style={labelStyle}>Total VAT Collected</span>
          <h2 style={{ ...valueStyle, color: '#ffd000' }}>
            TK {totalVatSum.toLocaleString()}/-
          </h2>
        </div>

        <div style={cardStyle}>
          <span style={labelStyle}>Net Revenue (Excl. VAT)</span>
          <h2 style={{ ...valueStyle, color: '#00a884' }}>
            TK {netRevenueExcludingVat.toLocaleString()}/-
          </h2>
        </div>
      </div>

      {/* MONTHLY BREAKDOWN TABLE */}
      <div style={tableWrapper}>
  <h3 style={{ padding: '15px', margin: 0, backgroundColor: '#170133' }}>Monthly Breakdown</h3>
  <table style={tableStyle}>
    <thead>
      <tr style={headerRowStyle}>
        <th>Month</th>
        <th>Invoices</th>
        <th>Gross Revenue</th>
        <th>Discounts</th>
        <th>Taxable Amount<br/>(Incl. Discounts)</th> {/* Added header to match the new column */}
        <th>Value Added Tax<br/>(VAT)</th>
        <th>Revenue<br/>(Incl. VAT)</th>
        <th>Net Revenue<br/>(Excl. VAT)</th>
      </tr>
    </thead>
    <tbody>
      {reportData.map((row, index) => {
        const gross = Number(row.grossRevenue) || 0;
        const discount = Number(row.totalDiscounts) || 0;
        
        // Calculate taxable amount using raw numeric variables
        const taxableAmount = gross - discount; 
        
        const vatPercent = typeof row.vat === 'string' 
          ? Number(row.vat.replace(/[^0-9.]/g, '')) 
          : (Number(row.vat) || 0);

        const vatAmount = taxableAmount * (vatPercent / 100);

        return (
          <tr key={index} style={rowStyle}>
            <td>{row.month}</td>
            <td>{row.invoiceCount}</td>
            <td>TK {gross.toLocaleString()}</td>
            <td style={{ color: '#e74c3c' }}>- TK {discount.toLocaleString()}</td>
            {/* Corrected math block */}
            <td>TK {taxableAmount.toLocaleString()}</td> 
            <td style={{ color: '#ffd000' }}>+ TK {vatAmount.toLocaleString()}</td>
            <td style={{ color: '#fff', gap: '10px' }}>TK {Number(row.netRevenue).toLocaleString()}</td>
            <td style={{ fontWeight: 'bold', color: '#00a884', gap: '10px' }}>TK {taxableAmount.toLocaleString()}</td> 
          </tr>
        );
      })}
    </tbody>
  </table>
</div>

    </div>
  );
};

// --- STYLES (Dark Mode Aesthetic) ---
const containerStyle = { padding: '10px', maxWidth: '1000px', margin: '0 auto' };
const statsGrid = { display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '20px', marginBottom: '30px' };
const cardStyle = { backgroundColor: '#170133', padding: '20px', borderRadius: '12px', textAlign: 'center', boxShadow: '0 4px 6px rgba(0,0,0,0.3)' };
const labelStyle = { color: '#ffffff', fontSize: '14px', textTransform: 'uppercase' };
const valueStyle = { fontSize: '28px', margin: '10px 0 0 0', color: '#ffffff' };

const tableWrapper = { backgroundColor: '#24014f', borderRadius: '12px', overflow: 'hidden', color: '#e9edef' };
const tableStyle = { width: '100%', borderCollapse: 'collapse' };
const headerRowStyle = { backgroundColor: '#0b0018', textAlign: 'left', color: '#8696a0' };
const rowStyle = { borderBottom: '1px solid #202c33', padding: '15px' };

export default Reports;
